import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ShippedOrders from "./shipped";
import UnShippedOrders from "./unshipped";
import ClosedOrders from "./closed";
import DeliveredOrders from "./delivered";

const tabs = [
  { name: "Shipped", href: "shipped" },
  { name: "Unshipped", href: "unshipped" },
  { name: "Delivered", href: "delivered" },
  { name: "Closed", href: "closed" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function AdminStoreOrders() {
  const navigate = useNavigate();
  const DEFAULT_ACTIVE_TAB = "shipped";
  const { active_tab } = useParams();
  const params = useParams();

  useEffect(() => {
    if (!active_tab) {
      navigate(`/admin/store-orders/${DEFAULT_ACTIVE_TAB}/1`);
    }
  });

  useEffect(() => {
    if (params["*"] === `store-orders/${active_tab}`) {
      navigate(`/admin/store-orders/${active_tab}/1`);
    }
    // eslint-disable-next-line
  }, [active_tab, params]);

  const toggle = (tab) => {
    if (active_tab !== tab) {
      navigate(`/admin/store-orders/${tab.href}/1`);
    }
  };

  return (
    <div className="store-page">
      <div className="sm:block">
        <div className="border-b border-gray-200 dark:border-none">
          <nav
            className="-mb-px flex space-x-8 overflow-x-scroll sm:overflow-hidden"
            aria-label="Tabs"
          >
            {tabs.map((tab) => (
              <button
                key={tab.name}
                onClick={() => {
                  toggle(tab);
                }}
                className={classNames(
                  tab.href === active_tab
                    ? "border-primary text-primary font-bold"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                  "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
                )}
                aria-current={tab.href === active_tab ? "page" : undefined}
              >
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
      </div>

      <div>
        {active_tab === "shipped" && <ShippedOrders />}
        {active_tab === "unshipped" && <UnShippedOrders />}
        {active_tab === "closed" && <ClosedOrders />}
        {active_tab === "delivered" && <DeliveredOrders />}
      </div>
    </div>
  );
}
